<template lang="html">
    <div>
        <Hero imgLink="/img/port.jpg"/>
        <ForgetPasswordForm />        
    </div>
</template>
<script>
import Hero from "../components/Hero.vue";
import ForgetPasswordForm from "../components/ForgetPassword/ForgetPasswordForm.vue";

export default {
  name: "Login",
  components: {
    Hero,
    ForgetPasswordForm,
  },
  methods: {},
};
</script>
<style lang="css"></style>